import React from 'react';
import {Approutes as Routes} from '../../routes/Approutes.js';

export default function Sidebar(props) {
    const { Usuario } = props;
    return (
        <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion toggled" style={{ background: "#C3352A" }} id="accordionSidebar">
            <a className="sidebar-brand d-flex align-items-center justify-content-center" href={`${process.env.URIURL}/inicio`}>
                <div className="sidebar-brand-icon rotate-n-15">
                    {/* <i className="fas fa-laugh-wink" style={{ color: "#E1C34C" }}></i> */}
                </div>
                <div className="sidebar-brand-text mx-3">{Usuario.nombre_tipo}</div>
            </a>
            <hr className="sidebar-divider my-0" />
            {Routes.map((prop, key) => {
                return  prop.show && prop.permisos.includes(Usuario.tipo_usuario) ?
                    <li className="nav-item" key={key}>
                        <a className="nav-link" href={`${process.env.URIURL}${prop.path}`}>
                            <i className={prop.icon}></i>
                            <span>{prop.name}</span></a>
                    </li> :''
                /*  <li className="nav-item dropdown" key={key} onClick={() => click()}>
                     
                 </li> */
            })}
            <hr className="sidebar-divider d-none d-md-block" />
        </ul>
    )
}
